export default "__VITE_ASSET__42084eb4__"